module.exports = __webpack_public_path__ + "img/xyjws1.e0115564.png";